import { Typography, Flex } from '@banhala/ui-kit';

export const useFilterHeader = ({ title }: { title: string }) => {
  const Header = () => {
    return (
      <Flex padding={{ vertical: 24 }}>
        <Typography type="h5" color="content_primary">
          {title}
        </Typography>
      </Flex>
    );
  };

  return {
    Header,
  };
};
